import { Chip } from "@mui/material";
import { Localized } from "@fluent/react";
import { IdentifierTypeEnum } from "./commonTypes";

type Props = {
    type: IdentifierTypeEnum;
    size?: "small" | "medium";
    variant?: "filled" | "outlined";
};

export const IdentifierTypeChip = ({
    type,
    size = "small",
    variant = "outlined",
}: Props) => {
    return (
        <Chip
            size={size}
            variant={variant}
            label={
                <Localized id={`counterparties-identifier-${type}`}>
                    <span>{type}</span>
                </Localized>
            }
            sx={{
                fontWeight: 500,
            }}
        />
    );
};